import { LegendlessDonutChart } from "../../../components";
import { Box, Text } from "@chakra-ui/react";
import { Card } from "../../../components/Card";

function SuppliersEngagementChart({ data }) {
  const getTooltip = (tooltipObj) => {
    const { datum: { data } } = tooltipObj;
    const formattedPercentageValue = data.percentageValue && data.percentageValue > 0 ?
      data.percentageValue.toLocaleString("en-GB", { maximumFractionDigits: 1 }) : "";

    return (
      <Box position="relative">
        <Card
          position="absolute"
          minWidth={"300px"}
          padding={3}
        >
          <Text fontSize="sm">
            {data.title} - <b>{formattedPercentageValue}% ({data.value} Supplier{data.value > 1 ? "s" : ""})</b>
          </Text>
        </Card>
      </Box>);
  };

  const getLabel = (el) => {
    return el.data.percentageValue && el.data.percentageValue > 0 ?
      `${el.data.percentageValue.toLocaleString("en-GB", { maximumFractionDigits: 1 })}%` : "";
  };

  return (
    <LegendlessDonutChart
      data={data}
      getTooltip={getTooltip}
      getLabel={getLabel}
      getLabelsTextColor={() => "white"}
    />
  )
}

export default SuppliersEngagementChart;